import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/agents/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/agents/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/agents/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/agents/delete',
    method: 'post',
    data
  })
}

